import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import moment from 'moment';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import Message from '../Common/Message/Message';
import EventsModal from './EventsModal/EventsModal';
import InvoiceModal from './InvoiceModal/InvoiceModal';
import en from './locales/en.json';
import fr from './locales/fr.json';

import './Payout.css';
import { string } from 'prop-types';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Payout extends Component {
	constructor(props) {
        super(props);
        this.state = {
            message: {
                title: '',
                content: '',
                type: '',
            },
            invoiceEventId: -1,
            selectedPage: 1,
            selectedLimit: 100,
            selectedCountry: 'us',
            selectedPayout: 'early',
            selectedType: 'early',
            selectedPayoutType: 'event',
            payouts: [],
            selectedEvents: [],
            selectedClientIds: [],
            events: [],
            isEventsModalOpen: false,
            selectedAmount: null,
            selectedMemo: '',
            selectedEventId: null,
            selectedEventName: null,
            tabs: [
                {
                    name: 'US Early Payout',
                    id: 'us_early_payout',
                    type: 'event'
                },
                {
                    name: 'CA Early Payout',
                    id: 'ca_early_payout',
                    type: 'event'
                },
                {
                    name: 'US 95% Event',
                    id: 'us_95_percent_event',
                    type: 'event'
                },
                {
                    name: 'US 5% Event',
                    id: 'us_5_percent_event',
                    type: 'event'
                },
                {
                    name: 'US 95% Flexpass',
                    id: 'us_95_percent_flexpass',
                    type: 'flexpass'
                },
                {
                    name: 'US 5% Flexpass',
                    id: 'us_5_percent_flexpass',
                    type: 'flexpass'
                },
                {
                    name: 'CA 95% Event',
                    id: 'ca_95_percent_event',
                    type: 'event'
                },
                {
                    name: 'CA 5% Event',
                    id: 'ca_5_percent_event',
                    type: 'event'
                },
                {
                    name: 'CA 95% Flexpass',
                    id: 'ca_95_percent_flexpass',
                    type: 'flexpass'
                },
                {
                    name: 'CA 5% Flexpass',
                    id: 'ca_5_percent_flexpass',
                    type: 'flexpass'
                }
            ]
        };
    }
    
    componentDidMount() {
        //this.getPayouts();
    }

    groupByKey = (array, key) => {
        return array
          .reduce((hash, obj) => {
            if(obj[key] === undefined) return hash; 
            return Object.assign(hash, { [obj[key]]:( hash[obj[key]] || [] ).concat(obj)})
          }, {})
    };

    convertPayouts = (payout) => {
        let payout_arr = [];
        payout.forEach((result) => {
            let payout_obj = {};
            payout_obj.events = result;
            payout_obj.isOpen = true;
            payout_obj.client_name = payout_obj.events[0].client_name;
            payout_obj.client_id = payout_obj.events[0].client_id;
            payout_obj.qb_vendor_name = payout_obj.events[0].qb_vendor_name;
            payout_obj.donation_amount = payout_obj.events[0].donation_amount;
            payout_obj.events.forEach((event) => {
                event.isSelected = false;
                event.isActionsOpen = false;
                event.charge_check_fee = event.payout_option !== 'check-at-close' ? 'N' : 'Y';
                if (event.payout_option !== 'check-at-close') {
                    event.charge_check_fee = 'N';
                } else {
                    if (event.payout_amount > 5) {
                        event.charge_check_fee = 'Y';
                    }
                    if (event.payout_amount < 5 && event.payout_amount > 0) {
                        event.charge_check_fee = 'N';
                    }
                    if (event.payout_amount <= 0) {
                        event.charge_check_fee = 'N';
                    }
                }
                if (event.eventPayoutType === '5_percent_payout' || event.flexpassPayoutType === '5_percent_payout') {
                    event.charge_check_fee = 'N';
                }
            });
            payout_arr.push(payout_obj);
        });
        return payout_arr;
    }

    getPayoutEvents = (events) => {
        events.isSelected = false;
        console.log(events)
        events.forEach((event) => {
            event.isSelected = false;
            event.isActionsOpen = false;
            if (event.payout_option !== 'check-at-closing') {
                event.charge_check_fee = 'N';
            } else {
                if (event.payout_amount > 5) {
                    event.charge_check_fee = 'Y';
                }
                if (event.payout_amount < 5 && event.payout_amount > 0) {
                    event.charge_check_fee = 'N';
                }
                if (event.payout_amount <= 0) {
                    event.charge_check_fee = 'N';
                }
            }
            if (event.eventPayoutType === '5_percent_payout' || event.flexpassPayoutType === '5_percent_payout') {
                event.charge_check_fee = 'N';
            }
        });
        return events;
    }

    getPayouts = (client_id: Number) => {
        this.setMessage('', '', 'loading');
        let selectedPage = this.state.selectedPage;
        let selectedLimit = this.state.selectedLimit;
        let selectedCountry = this.state.selectedCountry;
        let selectedPayout = this.state.selectedPayout;
        let selectedPayoutType = this.state.selectedPayoutType;
        (async () => {
            try {
                const getPayoutsResponse = await getPayouts(client_id, selectedPage, selectedLimit, selectedCountry, selectedPayout, selectedPayoutType);
                console.log('getPayoutsResponse: ', getPayoutsResponse);
                if (!getPayoutsResponse.data.error) {
                    let searchParams = getPayoutsResponse.data.search_params;
                    let payoutsOriginal = JSON.parse(JSON.stringify(this.state.payouts));
                    let payouts = this.state.payouts;
                    
                    console.log('payouts', payouts);
                    console.log('payouts before', payoutsOriginal);
                    payouts = getPayoutsResponse.data.data;
                    console.log('payouts', payouts);
                    

                    let payoutsConverted = this.groupByKey(payouts, 'client_id');
                    /* let ca_95_percent_payout = Object.values(this.groupByKey(payouts.ca_95_percent_payout, 'client_id'));
                    let us_5_percent_payout = Object.values(this.groupByKey(payouts.us_5_percent_payout, 'client_id'));
                    let us_95_percent_payout = Object.values(this.groupByKey(payouts.us_95_percent_payout, 'client_id'));
                    let early_payout = Object.values(this.groupByKey(payouts.early_payout, 'client_id')); */

                    console.log('payoutsConverted', payoutsConverted)

                    if (client_id) {
                        payoutsOriginal.forEach((client, index) => {
                            if (client.client_id === client_id) {
                                payoutsOriginal[index].events = this.getPayoutEvents(payouts);
                                if (payouts.length === 0) {
                                    payoutsOriginal.splice(index, 1);
                                }
                            }
                        });

                        payouts = payoutsOriginal;
                        console.log('payoutsOriginal', payoutsOriginal);
                        console.log('payouts', payouts);
                    } else {
                        payouts = this.convertPayouts(Object.values(payoutsConverted));
                    }

                    const compareOrder = (a, b) => {
                        if (a.client_name.toLowerCase() < b.client_name.toLowerCase()) return -1;
                        if (a.client_name.toLowerCase() > b.client_name.toLowerCase()) return 1;
                        return 0;
                    };
                    const payoutsOrdered = payouts.sort(compareOrder);
                    

                    console.log('payouts after', payoutsOrdered);

                    this.setMessage('', '', '');

                    this.setState({
                        payouts: payoutsOrdered,
                        selectedPage: searchParams.page,
                        selectedClientIds: [],
                        selectedEvents: [],
                        selectedAmount: null,
                        selectedMemo: '',
                        selectedEventId: null,
                        selectedEventName: null
                    });
                } else {
                    this.setState({
                        payouts: [],
                    })
                    this.setMessage(window.general_strings.msg.oops, getPayoutsResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function getPayouts(client_id, selectedPage, selectedLimit, selectedCountry, selectedPayout, selectedPayoutType) {
            let url = `/admin/payouts/data-sets?`;
            if (client_id) {
                url += `&client_id=${client_id}`
            }
            if (selectedPage) {
                url += `&page=${selectedPage}`
            }
            if (selectedLimit) {
                url += `&limit=${selectedLimit}`
            }
            if (selectedCountry) {
                url += `&country=${selectedCountry}`
            }
            if (selectedPayout) {
                url += `&payout_type=${selectedPayout}`
            }
            if (selectedPayoutType) {
                url += `&type=${selectedPayoutType}`
            }

            url = url.replace('?&', '?');

            return await ApiRequest(url, {
                method: 'GET'
            });
        }
    }
    
    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }    

    updateNote = (e, client_index, event_index) => {
        let results = this.state.results;
        results[client_index].events[event_index].notes = e.target.value;
        this.setState({
            results,
        });
    }

    toggleClient = (client_index) => {
        let payouts = this.state.payouts;
        payouts[client_index].isOpen = !payouts[client_index].isOpen;
        this.setState({
            payouts,
        });
    }
    
    toggleActions = (result_index, event_index) => {
        let payouts = this.state.payouts;
        let previousState = payouts[result_index].events[event_index].isActionsOpen;
        payouts.map((result) => result.events.map((event) => event.isActionsOpen = false ));
        if (previousState) {
            payouts[result_index].events[event_index].isActionsOpen = false;
        } else {
            payouts[result_index].events[event_index].isActionsOpen = !payouts[result_index].events[event_index].isActionsOpen;
        }
        
        this.setState({
            payouts,
        });
    }

    toggleEventSelection = (e, result_index, event_index) => {
        let payouts = this.state.payouts;
        // If specific client
        if (result_index >= 0) {
            // If specific event
            if (event_index >= 0) {
                payouts[result_index].events[event_index].isSelected = !payouts[result_index].events[event_index].isSelected;
            } else {
                payouts[result_index].isSelected = e.target.checked;
                payouts[result_index].events.forEach((event) => {
                    event.isSelected = e.target.checked;
                });
            }
        } else {
            // If all events
            payouts.forEach((result) => {
                result.events.forEach((event) => {
                    event.isSelected = e.target.checked;
                });
            });
        }
        
        this.setState(
            {
                payouts,
            },
            () => {
                this.updateSelectedIds();
            }
        );
    }

    updateSelectedIds = () => {
        let selectedEvents = [];
        let selectedClientIds = [];
        let payouts = this.state.payouts;
        payouts.forEach((result) => {
            result.events.forEach((event) => {
                if (event.isSelected) {
                    selectedEvents.push(event);
                    if (!selectedClientIds.includes(event.client_id)) {
                        selectedClientIds.push(event.client_id);
                    }
                }
            });
        });

        this.setState({
            selectedEvents,
            selectedClientIds,
        });
    }

    confirmInvoiceEvent = (event_id: number) => {
        let invoiceEventId = event_id;
        let isInvoiceModalOpen = this.state.isInvoiceModalOpen;
        isInvoiceModalOpen = true;

        this.setState({
            invoiceEventId,
            isInvoiceModalOpen,
        });
    }

    toggleInvoiceModal = () => {
        let invoiceEventId = this.state.invoiceEventId;
        let isInvoiceModalOpen = this.state.isInvoiceModalOpen;
        isInvoiceModalOpen = false;

        this.setState({
            invoiceEventId: null,
            isInvoiceModalOpen,
        });
    }

    confirmInvoice = (invoice: string) => {
        let invoiceEventId = this.state.invoiceEventId;
        let memo = invoice;
        this.invoiceEvent(invoiceEventId, memo);
    }

    invoiceEvent = (event_id: number, memo: string) => {
        this.setMessage('', '', 'loading');
        this.setState({
            isInvoiceModalOpen: false,
            invoiceEventId: -1,
        });
        let client_id = -1;
        let payouts = this.state.payouts;
        let amount = 0;
        let tender_type = 'Event Check';
        let event_name = '';

        for (let i = 0; i < payouts.length; i++) {
            payouts[i].events.forEach((event) => {
                if (event.event_id === this.state.invoiceEventId) {
                    client_id = payouts[i].client_id;
                    amount = event.payout_amount;
                    event_name = event.event_name;
                }
            })
        }

        (async () => {
            try {
                const invoiceResponse = await invoice(event_id, client_id, Math.abs(amount), tender_type, memo);
                console.log('invoiceResponse: ', invoiceResponse);
                if (!invoiceResponse.data.error) {
                    this.invoiceEvent2(event_id, client_id, amount, event_name);
                } else {
                    this.setMessage(window.general_strings.msg.oops, invoiceResponse.data.error.details[0].message,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function invoice(event_id, client_id, amount, tender_type, memo) {
            return await ApiRequest('/admin/withdrawals', {
                method: 'POST',
                data: {
                    event_id: event_id,
                    client_id: client_id,
                    amount: amount,
                    tender_type: tender_type,
                    memo: memo,
                    withdrawal_type: 'D',
                }
            });
        }
    }

    invoiceEvent2 = (event_id: number, client_id:number, amount:number, event_name: string) => {
        this.setMessage('', '', 'loading');
        let tender_type = 'Event Credit';
        let memo = `Sales for ${event_name}`;
        (async () => {
            try {
                const invoiceResponse = await invoice2(event_id, client_id, amount, tender_type, memo);
                console.log('invoiceResponse: ', invoiceResponse);
                if (!invoiceResponse.data.error) {
                    this.setMessage(window.general_strings.msg.yay, 'Invoice has been successful.', 'success');
                    setTimeout(() => {
                        this.getPayouts(client_id);
                    }, 2000);
                } else {
                    this.setMessage(window.general_strings.msg.oops, invoiceResponse.data.error.details[0].message,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function invoice2(event_id, client_id, amount, tender_type, memo) {
            return await ApiRequest('/admin/withdrawals', {
                method: 'POST',
                data: {
                    event_id: event_id,
                    client_id: client_id,
                    amount: amount,
                    tender_type: tender_type,
                    memo: memo,
                    withdrawal_type: 'C',
                }
            });
        }
    }

    payoutEvents = (event_id: number, invoice: string) => {
        this.setMessage('', '', 'loading');
        const selectedEvents = this.state.selectedEvents;
        const selectedPayoutType = this.state.selectedPayoutType;
        (async () => {
            try {
                let events = [];
                if (event_id) {
                    events.push(event_id);
                } else {
                    selectedEvents.forEach((selectedEvent) => {
                        let event = {};
                        const charge_check_fee_bool = (selectedEvent.charge_check_fee === 'Y');
                        event.charge_check_fee = charge_check_fee_bool;
                        event.id = selectedEvent.id;
                        events.push(event);
                    });
                }
                
                const payoutsResponse = await payouts(events, selectedPayoutType);
                console.log('payoutsResponse: ', payoutsResponse);
                if (payoutsResponse.data.event_ids) {
                    this.setMessage(window.general_strings.msg.yay, 'Payout has been successful.', 'success');
                    setTimeout(() => {
                        let selectedClientIds = this.state.selectedClientIds;
                        selectedClientIds.forEach((client_id) => {
                            this.getPayouts(client_id);
                        });
                        this.setState({
                            selectedEvents: [],
                            selectedClientIds: [],
                        })
                    }, 2000);
                } else {
                    this.setMessage(window.general_strings.msg.oops, 'Ooops','error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function payouts(events, selectedPayoutType) {
            let data = {};
            if (selectedPayoutType === 'flexpass') {
                data = {
                    flexpasses: events,
                }
            } else {
                data = {
                    events: events,
                }
            }
            return await ApiRequest('/admin/payouts/create', {
                method: 'POST',
                data,
            });
        }
    }

    transferDonation = (event_id: number, client_id: Number, amount: Number, tender_type: String, event_name: String) => {
        this.setMessage('', '', 'loading');
        (async () => {
            try {
                let memo = `Transfer of fees from ${event_name}`;
                const transferResponse = await transfer(event_id, client_id, amount, tender_type, memo);
                console.log('transferResponse: ', transferResponse);
                if (!transferResponse.data.error) {
                    this.transferDonation2(event_id, client_id, amount, event_name);
                } else {
                    this.setMessage(window.general_strings.msg.oops, transferResponse.data.error.details[0].message,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function transfer(event_id, client_id, amount, tender_type, memo) {
            return await ApiRequest('/admin/withdrawals', {
                method: 'POST',
                data: {
                    event_id: 0,
                    client_id: client_id,
                    amount: amount,
                    tender_type: tender_type,
                    memo: memo,
                    withdrawal_type: 'D',
                }
            });
        }
    }

    transferDonation2 = (event_id: number, client_id: Number, amount: Number, event_name: String) => {
        this.setMessage('', '', 'loading');
        (async () => {
            try {
                const transferResponse = await transfer(event_id, client_id, Math.abs(amount));
                console.log('transferResponse: ', transferResponse);
                if (!transferResponse.data.error) {
                    this.transferDonation3(event_id, client_id, amount, event_name);
                } else {
                    this.setMessage(window.general_strings.msg.oops, transferResponse.data.error.details[0].message,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function transfer(event_id, client_id, amount, tender_type, memo) {
            return await ApiRequest('/admin/withdrawals', {
                method: 'POST',
                data: {
                    event_id: event_id,
                    client_id: client_id,
                    amount: amount,
                    tender_type: 'Event Check',
                    memo: 'Transfer to donations',
                    withdrawal_type: 'D',
                }
            });
        }
    }

    transferDonation3 = (event_id: number, client_id: Number, amount: Number, event_name: String) => {
        this.setMessage('', '', 'loading');
        (async () => {
            try {
                const transferResponse = await transfer3(event_id, client_id, amount, event_name);
                console.log('transferResponse: ', transferResponse);
                if (!transferResponse.data.error) {
                    this.setMessage(window.general_strings.msg.yay, 'Transfer has been successful.', 'success');
                    setTimeout(() => {
                        this.getPayouts(client_id);
                    }, 2000);
                } else {
                    this.setMessage(window.general_strings.msg.oops, transferResponse.data.error.details[0].message,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function transfer3(event_id, client_id, amount, name) {
            return await ApiRequest('/admin/withdrawals', {
                method: 'POST',
                data: {
                    event_id: event_id,
                    client_id: client_id,
                    amount: amount,
                    tender_type: 'Event Credit',
                    memo: `Sales for ${name}`,
                    withdrawal_type: 'C',
                }
            });
        }
    }

    transferEvent = (event_id: number, client_id: Number, amount, name) => {
        this.getClientEvents(client_id);
        this.toggleEventsModal();

        let selectedEventName = name;
        let selectedEventId = event_id;
        let selectedAmount = amount;
        let selectedMemo = `Transfer of fees from ${name}`;
        this.setState({
            selectedAmount,
            selectedMemo,
            selectedEventId,
            selectedEventName,
        });
    }

    transferToEvent = (event_id, client_id, tender_type) => {
        this.setState({
            isEventsModalOpen: false,
        });
        let amount = this.state.selectedAmount;
        let memo = this.state.selectedMemo;
        this.setMessage('', '', 'loading');
        (async () => {
            try {
                const transferResponse = await transfer(event_id, client_id, amount, tender_type, memo);
                console.log('transferResponse: ', transferResponse);
                if (!transferResponse.data.error) {
                    this.transferToEvent2(client_id, amount);
                } else {
                    this.setMessage(window.general_strings.msg.oops, transferResponse.data.error.details[0].message, 'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function transfer(event_id, client_id, amount, tender_type, memo) {
            return await ApiRequest('/admin/withdrawals', {
                method: 'POST',
                data: {
                    event_id: event_id,
                    client_id: client_id,
                    amount: amount,
                    tender_type: tender_type,
                    memo: memo,
                    withdrawal_type: 'D',
                }
            });
        }
    }

    transferToEvent2 = (client_id, amount) => {
        let selectedEventId = this.state.selectedEventId;
        this.setMessage('', '', 'loading');
        (async () => {
            try {
                const transferResponse = await transfer2(selectedEventId, client_id, Math.abs(amount));
                console.log('transferResponse: ', transferResponse);
                if (!transferResponse.data.error) {
                    this.transferToEvent3(client_id, amount)
                } else {
                    this.setMessage(window.general_strings.msg.oops, transferResponse.data.error.details[0].message, 'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function transfer2(event_id, client_id, amount) {
            return await ApiRequest('/admin/withdrawals', {
                method: 'POST',
                data: {
                    event_id: event_id,
                    client_id: client_id,
                    amount: amount,
                    tender_type: 'Event Check',
                    memo: 'Fees transferred',
                    withdrawal_type: 'D',
                }
            });
        }
    }

    transferToEvent3 = (client_id, amount) => {
        let selectedEventId = this.state.selectedEventId;
        let selectedEventName = this.state.selectedEventName;
        this.setMessage('', '', 'loading');
        (async () => {
            try {
                const transferResponse = await transfer3(selectedEventId, client_id, amount, selectedEventName);
                console.log('transferResponse: ', transferResponse);
                if (!transferResponse.data.error) {
                    this.setMessage(window.general_strings.msg.yay, 'Transfer has been successful.', 'success');
                    setTimeout(() => {
                        this.getPayouts(client_id);
                        this.setState({
                            selectedAmount: null,
                            selectedMemo: '',
                            selectedEventId: null,
                            selectedEventName: null,
                        });
                    }, 2000);
                } else {
                    this.setMessage(window.general_strings.msg.oops, transferResponse.data.error.details[0].message, 'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function transfer3(event_id, client_id, amount, name) {
            return await ApiRequest('/admin/withdrawals', {
                method: 'POST',
                data: {
                    event_id: event_id,
                    client_id: client_id,
                    amount: amount,
                    tender_type: 'Event Credit',
                    memo: `Sales for ${name}`,
                    withdrawal_type: 'C',
                }
            });
        }
    }

    toggleEventsModal = () => {
        this.setState({
            isEventsModalOpen: !this.state.isEventsModalOpen,
        });
    }

    getClientEvents = (client_id: Number) => {
        this.setMessage('', '', 'loading');
        (async () => {
            try {
                const responseEvents = await getEvents(client_id);
                console.log('Get Client Events: ', responseEvents);
                if (responseEvents.data.events) {
                    this.setMessage('', '', '');
                    let events = responseEvents.data.events;
                    this.setState({
                        events,
                    });
                } else {
                    this.setMessage(window.general_strings.msg.oops, 'Error retrieving events.', 'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function getEvents(client_id) {
            return await ApiRequest(`/event-listing/${client_id}`);
        }
    }

    handleLimitSelection = (e) => {
        const value = e.target.value;
        let selectedLimit = this.state.selectedLimit;
        selectedLimit = parseInt(value, 10);
        this.setState({ selectedLimit });
    }

    handlePageSelection = (e) => {
        const value = e.target.value;
        let selectedPage = this.state.selectedPage;
        selectedPage = parseInt(value, 10);
        this.setState({ selectedPage });
    }

    handleTypeSelection = (e) => {
        const value = e.target.value;
        let selectedPayout = this.state.selectedPayout;
        let selectedType = this.state.selectedType;
        let selectedCountry = this.state.selectedCountry;
        let selectedPayoutType = this.state.selectedPayoutType;
        selectedPayout = value;
        selectedType = value;
        selectedPayoutType = e.target.options[e.target.selectedIndex].dataset.type;
        switch (value) {
            case 'us_early_payout':
            selectedCountry = 'us';
            selectedPayout = 'early';
            break;

            case 'ca_early_payout':
            selectedCountry = 'ca';
            selectedPayout = 'early';
            break;

            case 'us_95_percent_event':
            selectedCountry = 'us';
            selectedPayout = '95-percent-payout';
            break;

            case 'ca_95_percent_event':
            selectedCountry = 'ca';
            selectedPayout = '95-percent-payout';
            break;

            case 'us_5_percent_event':
            selectedCountry = 'us';
            selectedPayout = '5-percent-payout';
            break;

            case 'ca_5_percent_event':
            selectedCountry = 'ca';
            selectedPayout = '5-percent-payout';
            break;

            case 'us_95_percent_flexpass':
            selectedCountry = 'us';
            selectedPayout = '95-percent-payout';
            break;

            case 'ca_95_percent_flexpass':
            selectedCountry = 'ca';
            selectedPayout = '95-percent-payout';
            break;

            case 'us_5_percent_flexpass':
            selectedCountry = 'us';
            selectedPayout = '5-percent-payout';
            break;

            case 'ca_5_percent_flexpass':
            selectedCountry = 'ca';
            selectedPayout = '5-percent-payout';
            break;
        }
        this.setState({ 
            selectedPayout,
            selectedCountry,
            selectedType,
            selectedPayoutType,
        });
    }

    handleCheckFeeSelection = (e, result_index, event_index) => {
        const value = e.target.value;
        let payouts = this.state.payouts;
        payouts[result_index].events[event_index].charge_check_fee = value;
        this.setState({ 
            payouts,
        });
    }

    handleSearch = () => {
        this.getPayouts();
    }

    renderClientHeader = () => {
        return (
            <table className="showtix-table showtix-table__striped">
                <thead>
                    <tr>
                        <th style={{ width: 20 }}>
                            <div className="showtix-form__checkbox">
                                <input
                                    type="checkbox"
                                    className="showtix-input"
                                    id="input-all"
                                    onChange={(e) => this.toggleEventSelection(e, undefined, undefined)}
                                />
                                <label className="showtix-label" htmlFor="input-all"></label>
                            </div>
                        </th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th style={{ width: 130 }}></th>
                        <th></th>
                    </tr>
                </thead>
            </table>
        );
    }

    renderEventHeader = () => {
        return (
            <tr className="showtix-event-title">
                <td>
                    
                </td>
                <td>
                    {this.state.selectedPayoutType === 'event' ? (
                        <React.Fragment>
                            {strings.eventName} - {strings.eventId}
                        </React.Fragment>
                    ) : (
                        strings.flexpassName
                    )}
                </td>
                <td>
                    {this.state.selectedPayoutType === 'event' ? (
                        strings.maxEventDate
                    ) : (
                        strings.maxFlexpassDate
                    )}
                </td>
                <td>
                    {this.state.selectedPayoutType === 'event' ? (
                        strings.eventEmail
                    ) : (
                        strings.flexpassEmail
                    )}
                </td>
                <td>
                    {this.state.selectedPayoutType === 'event' ? (
                        strings.eventType
                    ) : (
                        strings.flexpassType
                    )}
                </td>
                <td>
                    {strings.status}
                </td>
                <td>
                    {strings.licensingHouse}
                </td>
                <td>
                    {strings.payoutAmount}
                </td>
                <td>
                    {strings.payoutOption}
                </td>
                <td>
                    {strings.notes}
                </td>
                <td>
                    
                </td>
            </tr>
        );
    }

    renderResults = () => {
        let payouts = this.state.payouts;
        let results = payouts;
        if (results.length > 0) {
            return (
                results.map((result, result_index) => (
                    <React.Fragment>
                        {this.renderClient(result, result_index)}
                        {result.isOpen && (
                            <table className="showtix-table showtix-table__striped">
                                <thead>
                                    {this.renderEventHeader()}
                                </thead>
                                <tbody>
                                    {result.events.map((event, event_index) => (
                                        this.renderEvent(result, result_index, event, event_index)
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </React.Fragment>
                ))
            );
        } else {
            return (
                <p>Sorry, there's no result.</p>
            );
        }
    }

    renderClient = (result, result_index) => {
        return (
            <div className={"showtix-client " + (result.isOpen && 'is-open')} key={result_index} onClick={() => this.toggleClient(result_index)}>
                <div className="showtix-form__checkbox">
                    <input
                        type="checkbox"
                        className="showtix-input"
                        id={`client-${result_index}-all`}
                        checked={result.isSelected}
                        onChange={(e) => this.toggleEventSelection(e, result_index, undefined)}
                    />
                    <label
                        className="showtix-label"
                        htmlFor={`client-${result_index}-all`}
                    ></label>
                </div>
                <div className="showtix-client__infos">
                    <h3 className="showtix-client__name">
                        {result.client_name}
                        <span className="showtix-client__vendor-name">
                            ({result.qb_vendor_name})
                        </span>
                    </h3>
                    <p className="showtix-client__donation">
                        Donations: {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(result.donation_amount)}
                    </p>
                </div>
            </div>
        );
    }

    renderEvent = (result, result_index, event, event_index) => {
        return (
            <tr className={"showtix-event" + (event.payout_amount < 0 ? ' is-negative' : '') + (event.tax_1099_received ? '' : ' is-pending') + (event.legal_entity_id === null ? ' is-pending' : '')} key={`client-${result_index}-event-${event_index}`}>
                <td>
                    {event.payout_amount >= 0 && (
                        <div className="showtix-form__checkbox">
                            <input
                                type="checkbox"
                                className="showtix-input"
                                id={`client-${result_index}-event-${event_index}`}
                                checked={event.isSelected}
                                onChange={(e) => this.toggleEventSelection(e, result_index, event_index)}
                            />
                            <label className="showtix-label" htmlFor={`client-${result_index}-event-${event_index}`}></label>
                        </div>
                    )}
                </td>
                <td>
                    {event.name ? event.name : event.event_name} - {event.event_id}
                </td>
                <td>
                    {moment(event.max_event_datetime).format('LLLL')}
                </td>
                <td>
                    {event.event_contact_email ? event.event_contact_email : event.contact_email}
                </td>
                <td>
                    {event.event_type ? event.event_type : 'Flexpass'}
                </td>
                <td>
                    {event.status}
                </td>
                <td>
                    {event.licensing}
                </td>
                <td>
                    {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(event.payout_amount)}
                </td>
                <td>
                    {event.payout_option === 'check-at-close' ? (
                        <div className="showtix-form__group">
                            <label htmlFor={`check-fee-${event_index}`}>{event.payout_option} {strings.fee}</label>
                            <div className="showtix-form__select">
                                <select className="showtix-input"
                                    id={`check-fee-${event_index}`}
                                    value={event.charge_check_fee}
                                    onChange={e => this.handleCheckFeeSelection(e, result_index, event_index)}
                                >
                                    <option value="Y" disabled={event.payout_amount <= 0 || (event.eventPayoutType === '5_percent_payout' || event.flexpassPayoutType === '5_percent_payout')}>{strings.yes}</option>
                                    <option value="N">{strings.no}</option>
                                </select>
                            </div>
                        </div>
                    ) : (
                        <div className="showtix-form__group">
                            <label htmlFor={`check-fee-${event_index}`}>{event.payout_option} {strings.fee}</label>
                            <div className="showtix-form__select">
                                <select className="showtix-input"
                                    id={`check-fee-${event_index}`}
                                    value={'N'}
                                    disabled={true}
                                >
                                    <option value="Y">{strings.yes}</option>
                                    <option value="N">{strings.no}</option>
                                </select>
                            </div>
                        </div>
                    )}
                </td>
                <td>
                    {event.accounting_notes}
                    {/* <input
                        type="text"
                        value={event.accounting_notes}
                        className="showtix-input"
                        readOnly={true}
                        //onChange={(e) => this.updateNote(e, result_index, event_index)}
                    /> */}
                </td>
                <td>
                    {event.payout_amount < 0 && (
                        <div className="showtix-event__actions">
                            <button
                                className="showtix-button showtix-button__small showtix-button__action"
                                onClick={() => this.toggleActions(result_index, event_index)}
                            >
                                <span>...</span>
                            </button>
                            {event.isActionsOpen && (
                                <div className="showtix-event__buttons">
                                    {event.payout_amount < 0 && (
                                        <button
                                            className="showtix-button showtix-button__small showtix-background__primary-1"
                                            onClick={() => this.confirmInvoiceEvent(event.event_id)}
                                        >
                                            <span>{strings.invoice}</span>
                                        </button>
                                    )}
                                    {event.payout_amount < 0 && (
                                        <button
                                            className="showtix-button showtix-button__small showtix-background__primary-2"
                                            onClick={() => this.transferDonation(event.event_id, event.client_id, event.payout_amount, 'Fee', event.event_name)}
                                        >
                                            <span>{strings.transferDonation}</span>
                                        </button>
                                    )}
                                    {event.payout_amount < 0 && (
                                        <button
                                            className="showtix-button showtix-button__small showtix-background__primary-3"
                                            onClick={() => this.transferEvent(event.event_id, event.client_id, event.payout_amount, event.event_name)}
                                        >
                                            <span>{strings.transferEvent}</span>
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </td>
            </tr>
        );
    }

    renderButtons = () => {
        const selectedEvents = this.state.selectedEvents;
        if (selectedEvents.length > 0) {
            return (
                <div className="mt-3 mb-3 display-flex flex-align-end">
                    <button
                        className="showtix-button showtix-background__primary-1"
                        onClick={() => this.payoutEvents()}
                        disabled={this.state.message.type === 'loading'}
                    ><span>{this.state.selectedPayoutType === 'event' ? (
                        strings.invoiceSelected
                    ) : (
                        strings.invoiceFlexpassSelected
                    )}</span></button>
                </div>
            );
        } else {
            return null;
        }
    }

    renderPanels = () => {
        const payouts = this.state.payouts;
        let selectedPayout = this.state.selectedPayout;
        let selectedCountry = this.state.selectedCountry;
        let selectedPayoutName = 'US Early Payout';
        switch (selectedPayout) {
            case 'early':
                if (selectedCountry === 'us') {
                    selectedPayoutName = 'US Early Payout';
                }

                if (selectedCountry === 'ca') {
                    selectedPayoutName = 'CA Early Payout';
                }
            break;

            case '95-percent-payout':
                if (selectedCountry === 'us') {
                    selectedPayoutName = 'US 95% Payout';
                }

                if (selectedCountry === 'ca') {
                    selectedPayoutName = 'CA 95% Payout';
                }
            break;

            case '5-percent-payout':
                if (selectedCountry === 'us') {
                    selectedPayoutName = 'US 5% Payout';
                }

                if (selectedCountry === 'ca') {
                    selectedPayoutName = 'CA 5% Payout';
                }
            break;
        }
        if (payouts.length > 0) {
            return (
                <React.Fragment>
                    <h2>{selectedPayoutName}</h2>
                    {this.renderButtons()}
                    {this.renderResults()}
                </React.Fragment>
            );
        } else {
            return <p>Sorry, there's no result.</p>;
        }
    }

    renderForm = () => {
        return (
            <React.Fragment>
                <div className="row d-flex align-items-center justify-content-between">
                    <div className="col-md-4 col-12">
                        <div className="showtix-form__group">
                            <label htmlFor="type" className="">Type of Payout</label>
                            <div className="showtix-form__select">
                                <select className="showtix-input"
                                    id="type"
                                    value={this.state.selectedType}
                                    onChange={e => this.handleTypeSelection(e)}
                                >
                                    {this.state.tabs.map((tab) => (
                                        <option value={tab.id} data-type={tab.type}>{tab.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-12">
                        <div className="showtix-form__group">
                            <label htmlFor="limit" className="">Limit</label>
                            <div className="showtix-form__select">
                                <select className="showtix-input"
                                    id="limit"
                                    value={this.state.selectedLimit}
                                    onChange={e => this.handleLimitSelection(e)}
                                >
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-12">
                        <div className="showtix-form__group">
                            <label htmlFor="pagination" className="">Pagination</label>
                            <div className="showtix-form__select">
                                <select className="showtix-input"
                                    id="pagination"
                                    value={this.state.selectedPage}
                                    onChange={e => this.handlePageSelection(e)}
                                >
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <button
                            className="showtix-button showtix-background__primary-1"
                            onClick={this.handleSearch}
                        >Apply</button>
                    </div>
                </div>
                <hr className="color-1" />
            </React.Fragment>
        );
    }

    render() {
		return (
            <div className="showtix-section container">
                <div className="row">
                    <div className="col-12">
                        <h1>{strings.title}</h1>
                        <Message
                            message={this.state.message}
                        />
                        <EventsModal
                            toggleEventsModal={this.toggleEventsModal}
                            transferToEvent={this.transferToEvent}
                            isEventsModalOpen={this.state.isEventsModalOpen}
                            events={this.state.events}
                        />
                        <InvoiceModal
                            toggleInvoiceModal={this.toggleInvoiceModal}
                            confirmInvoice={this.confirmInvoice}
                            isInvoiceModalOpen={this.state.isInvoiceModalOpen}
                        />
                        {this.renderForm()}
                        {this.renderPanels()}
                    </div>
                </div> 
            </div>     
		);
  	}
}

export default Payout;


// WEBPACK FOOTER //
// ./src/components/Payout/Payout.js